<template>
    <Layout>
<!--        <div class="row">-->
<!--            <div class="col-12">-->
<!--                <div class="page-title-box">-->
<!--                    <div class="page-title-right"></div>-->
<!--                    <h4 class="page-title">Batch Report </h4>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(trainee).length !== 0">
            <div class="row">
                <div class="col-md-12">
                    <b-card>
                        <div class="text-center clear" style="margin-top: -25px;">
                            <span style="font-size: 18px">Batch Report</span> <br />
                            <span>Batch No: {{ trainee.batch_no }} | Training Trade: {{ trainee.trade.desc }}</span><br />
                            Venue: {{ trainee.venue.desc }}<br />
                            Duration: {{ trainee.duration.desc }}<br />
                            Total Class {{ total_attendance }} Out of {{ total_working_days }}, Remaining  {{ total_remaining_days }}<br />
                        </div>
                    </b-card>
                    <b-card>
                        <div class="row mb-2">
                            <div class="col-md-12">
                                <span class="badge badge-success">Total Search Data Found: {{ trainee.trainees.length }}</span>
                            </div>
                        </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Trainee Name</th>
                                <th>Total Days</th>
                                <th>Total Present</th>
                                <th>Total Absent</th>
                            </tr>
                            </thead>
                            <tbody v-for="(batch, index) in batches" :key="index">
                            <tr v-for="(trainee, index) in batch.trainees" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <router-link :to="{
                                        name: 'traineeView',
                                        params: { trainee_id: trainee.id }}" tag="a" target="_blank">{{ trainee.rep_name ?  trainee.rep_name : trainee.name }}
                                    </router-link>
                                </td>
                                <td>{{ totalDays(trainee.present_attendance, trainee.absent_attendance) }}</td>
                                <td style="background-color: #d0f7dc;">
                                    <router-link :to="{
                                        name: 'traineeAttendanceReport',
                                        params: { trainee_id: trainee.id }}" tag="a" target="_blank" style="display: block;">
                                        {{ trainee.present_attendance }}
                                    </router-link>
                                </td>
                                <td  style="background-color: #f2cece">
                                    {{ trainee.absent_attendance }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-card>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Batch Report",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Batch Report",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Batch Report",
                        active: true
                    }
                ],

                trainee: {},
                batches: [],
                total_attendance: "",
                total_working_days: "",
                total_remaining_days: "",
            };
        },

        mounted() {
            this.getBatchTrainee();
        },
        methods: {
            getBatchTrainee() {
                let batch_id = this.$route.params.batch_id;
                http.get("api/getBatchTrainees/" + batch_id).then(response => {
                    if (!response.data.error) {
                        this.batches = response.data.batches;
                        this.trainee = response.data.trainee;
                        this.total_attendance = response.data.total_attendance;
                        this.total_working_days = response.data.total_working_days;
                        this.total_remaining_days = response.data.total_remaining_days;
                    }
                });
            },
            countPresent(attendances) {
                let count = 0;
                attendances.filter(p => {
                    if (p.is_attend !== null && p.is_attend === 1) {
                        count += 1;
                    }
                });
                return count;
            },
            countAbsent(attendances) {
                let count = 0;
                attendances.filter(p => {
                    if (p.is_attend !== null && p.is_attend === 0) {
                        count += 1;
                    }
                });
                return count;
            },
            totalDays(total_present, total_absent){
                return parseInt(total_present) + parseInt(total_absent) ;
            }
        },
    };
</script>
